import React, {useEffect, useState} from "react";
import markerIconPng from '../assets/pin-icon.jpeg';
import Image01 from '../assets/images/01_babie_lato.png';
import Image02 from '../assets/images/02_bociany.png';
import Image03 from '../assets/images/03_chlopi.png';
import Image04 from '../assets/images/04_folklor_sieradzki.png';
import Image05 from '../assets/images/05_jozio.png';
import Image06 from '../assets/images/06_kobieta_z_kura.png';
import Image07 from '../assets/images/07_na_pastwisku.png';
import Image08 from '../assets/images/08_ojczyzna.png';
import Image09 from '../assets/images/09_panna_mloda.png';
import Image10 from '../assets/images/10_podworko.png';
import Image11 from '../assets/images/11_rusalka.png';
import Image12 from '../assets/images/12_wiosna.png';
import Image13 from '../assets/images/13_zniwa.png';
import Image14 from '../assets/images/14_jesien_z_kaczka.png';
import Image15 from '../assets/images/15_kura.png';

import { TileLayer, Marker } from "react-leaflet";
import { Icon } from "leaflet";
import {
	MapContainer,
	Popup,
	Image,
	PopupHeader,
	PopupText,
	PopupLink,
	PopupContentContainer,
} from "./styled";

const markers = [
	{
		coords: [51.8371612,18.9105958],
		textPl: `BABIE LATO - JÓZEF CHEŁMOŃSKI
Przystanek Nowy Pudłów, gmina Poddębice
realizacja: Sylwester Stabryła, 2015 r.
`,
		textEn: `INDIAN SUMMER - JÓZEF CHEŁMOŃSKI
Nowy Pudłów bus stop, municipality of Poddębice
implementation: Sylwester Stabryła, 2015
`,
		img: Image01,
	},
	{
		coords: [51.9169529,19.0857319],
		textPl: `BOCIANY - Józef Chełmoński
Brudnów, gmina Dalików
realizacja: Marcin Jaszczak, 2020
`,
		textEn: `STORKS - Józef Chełmoński
Brudnów, municipality of Dalików
implementation: Marcin Jaszczak, 2020
`,
		img: Image02,
	},
	{
		coords: [51.848584,18.9733502],
		textPl: `CHŁOPI - Sylwester Stabryła
Góra Bałdrzychowska, gmina Poddębice
realizacja: Sylwester Stabryła, 2017
`,
		textEn: `PEASANTS - Sylwester Stabryła
Góra Bałdrzychowska, municipality of Poddębice
implementation: Sylwester Stabryła, 2017
`,
		img: Image03,
	},
	{
		coords: [51.8309762,18.9062378],
		textPl: `FOLKLOR SIERADZKI 
Przystanek: Pudłówek, gmina Poddębice
realizacja: Natalia Grala, 2016 r.
`,
		textEn: `SIERADZ FOLKLORE 
Przystanek: Pudłówek, municipality of Poddębice
implementation: Natalia Grala, 2016 r.
`,
		img: Image04,
	},
	{
		coords: [51.7961086,19.0042281],
		textPl: `PORTRET JÓZIA FELDMANA I SŁONECZNIK - Stanisław Wyspiański
Jeżew, gmina Zadzim
realizacja: Sylwester Stabryła, 2020
`,
		textEn: `PORTRAIT OF JÓZIO FELDMAN AND SUNFLOWER - Stanisław Wyspiański
Jeżew, municipality of Zadzim
implementation: Sylwester Stabryła, 2020
`,
		img: Image05,
	},
	{
		coords: [51.936319, 18.961946],
		textPl: `KOBIETA Z KURĄ - Julian Fałat
Sędów, gmina Wartkowice
realizacja: Sylwester Stabryła, 2020
`,
		textEn: `WOMAN WITH A HEN - Julian Fałat
Sędów, municipality of Wartkowice
implementation: Sylwester Stabryła, 2020
`,
		img: Image06,
	},
	{
		coords: [51.9226736,18.9495132],
		textPl: `NA PASTWISKU - Stanisław Witkiewicz
Chropy, gmina Poddębice
realizacja: Sylwester Stabryła, 2020
`,
		textEn: `ON THE PASTURE - Stanisław Witkiewicz
Chropy, municipality of Poddębice
implementation: Sylwester Stabryła, 2020
`,
		img: Image07,
	},
	{
		coords: [51.8145885,18.9736304],
		textPl: `OJCZYZNA - Jacek Malczewski
Anusin, gmina Poddębice
realizacja: Natalia Grala, 2018
`,
		textEn: `MOTHERLAND - Jacek Malczewski
Anusin, municipality of Poddębice
implementation: Natalia Grala, 2018
`,
		img: Image08,
	},
	{
		coords: [51.851688,18.9114617],
		textPl: `PANNA MŁODA - Piotr Stachiewicz
Busina, gmina Poddębice
realizacja: Sylwester Stabryła, 2018
`,
		textEn: `THE BRIDE - Piotr Stachiewicz
Busina, municipality of Poddębice
implementation: Sylwester Stabryła, 2018
`,
		img: Image09,
	},
	{
		coords: [51.8351308,18.8061674],
		textPl: `WIEJSKIE PODWÓRKO – Tadeusz Makowski
Drużbin, gmina Pęczniew
realizacja: Olga Pelipas, 2020
`,
		textEn: `VILLAGE BACKYARD – Tadeusz Makowski
Drużbin, municipality of Pęczniew
implementation: Olga Pelipas, 2020
`,
		img: Image10,
	},
	{
		coords: [51.7966065,18.767548],
		textPl: `RUSAŁKA RUDNICKA
Rudniki, gmina Pęczniew
realizacja: Marcin Jaszczak, 2020
`,
		textEn: `RUDNIKI RUSALKA
Rudniki, municipality of Pęczniew
implementation: Marcin Jaszczak, 2020
`,
		img: Image11,
	},
	{
		coords: [51.8238478,18.9247639],
		textPl: `WIOSNA - Jacek Malczewski
Anusin, gmina Poddębice
realizacja: Sylwester Stabryła, 2018
`,
		textEn: `SPRING - Jacek Malczewski
Anusin, municipality of Poddębice
implementation: Sylwester Stabryła, 2018
`,
		img: Image12,
	},
	{
		coords: [51.8439662,19.0025889],
		textPl: `ŻNIWA - Włodzimierz Przerwa-Tetmajer
Wólka, gmina Poddębice
realizacja: Natalia Grala, 2018
`,
		textEn: `HARVEST - Włodzimierz Przerwa-Tetmajer
Wólka, municipality of Poddębice
implementation: Natalia Grala, 2018
`,
		img: Image13,
	},
	{
		coords: [51.927360, 19.061558],
		textPl: `JESIEŃ Z KACZKĄ
Domaniew, gmina Dalików
realizacja: Adam Szczęsny 2022
`,
		textEn: `AUTUMN WITH A DUCK
Domaniew, municipality of Dalików
implementation: Adam Szczęsny 2022
`,
		img: Image14,
	},
	{
		coords: [51.933139, 19.127333],
		textPl: `KURA
Budzynek, gmina Dalików
realizacja: Adam Szczęsny 2022
`,
		textEn: `HEN
Budzynek, municipality of Dalików
implementation: Adam Szczęsny 2022
`,
		img: Image15,
	},
]

function Map() {
	const [lang, setLang] = useState('pl');

	useEffect(() => {
		const location = window.location;
		const urlParams = new URLSearchParams(location.search);
		const lang = urlParams.get("lang") || "pl";

		setLang(lang);
	}, []);

	const sendMsg = (x, y) => {
		window.sendMessageToNative(`${x},${y}`);
	}

	return (
		<MapContainer
			center={[51.85815867924132, 18.918354222748135]}
			zoom={10}
			scrollWheelZoom={false}
		>
			<TileLayer
				attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>
			{markers.map((marker, index) => (
				<Marker
					key={index}
					position={marker.coords}
					icon={
						new Icon({
							iconUrl: markerIconPng,
							iconSize: [40, 40],
							iconAnchor: [20, 20],
						})
					}
				>
					<Popup>
						<PopupContentContainer>
							<Image
								src={marker.img}
								alt="Przystanek"
							/>
							<PopupHeader>{lang === 'pl' ? marker.textPl : marker.textEn}</PopupHeader>
							<PopupText>{lang === 'pl' ? 'Znajdziesz tu kod QR' : 'You can scan a QR code here'}</PopupText>
							<PopupLink
								onClick={() => sendMsg(marker.coords[0], marker.coords[1])}
								// href={`https://www.google.com/maps/dir/?api=1&destination=${marker.coords[0]},${marker.coords[1]}&travelmode=driving`}
							>
								{lang === 'pl' ? 'Nawiguj' : 'Navigate'}
							</PopupLink>
						</PopupContentContainer>
					</Popup>
				</Marker>
			))}
		</MapContainer>
	);
}

export default Map;
